import { createIcon } from '@chakra-ui/icons';

export const LoaderBars = createIcon({
  displayName: 'LoaderBars',
  viewBox: '0 0 14 14',
  path: [
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2713_24316)">
        <path d="M7.875 0H6.125V3.5H7.875V0Z" fill="currentColor" />
        <path
          opacity="0.9"
          d="M11.3303 1.43091L8.85547 3.90576L10.0929 5.14319L12.5677 2.66834L11.3303 1.43091Z"
          fill="currentColor"
        />
        <path opacity="0.8" d="M14 6.125H10.5V7.875H14V6.125Z" fill="currentColor" />
        <path
          opacity="0.7"
          d="M10.0929 8.85633L8.85547 10.0938L11.3303 12.5686L12.5677 11.3312L10.0929 8.85633Z"
          fill="currentColor"
        />
        <path opacity="0.6" d="M7.875 10.5H6.125V14H7.875V10.5Z" fill="currentColor" />
        <path
          opacity="0.5"
          d="M3.90649 8.85572L1.43164 11.3306L2.66907 12.568L5.14392 10.0931L3.90649 8.85572Z"
          fill="currentColor"
        />
        <path opacity="0.4" d="M3.5 6.125H0V7.875H3.5V6.125Z" fill="currentColor" />
        <path
          opacity="0.3"
          d="M2.66907 1.43201L1.43164 2.66943L3.90649 5.14428L5.14392 3.90686L2.66907 1.43201Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2713_24316">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
